import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-46">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-47">
          {label}
        </label>}
      <input className={`
          w-full px-4 py-3 rounded-lg border bg-white
          focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all
          placeholder:text-gray-400
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-200'}
          ${className}
        `} {...props} data-id="element-48" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-49">{error}</p>}
    </div>;
}